/* eslint-disable max-len */
import { GetIAMAvailableModulesRequest } from '@1po/1po-bff-fe-spec/generated/catalog/available_modules/requerst/GetIAMAvailableModulesRequest';
import { GET_IAM_AVAILABLE_MODULES_TREE_URL } from '@1po/1po-bff-fe-spec/generated/common/WebsocketConstants';
import { WebSocketAction } from 'utils';
import { wsSendAction } from 'utils/domainStore/api';

export function sendIAMAvailableModulesRequest(request: GetIAMAvailableModulesRequest): WebSocketAction {
  return wsSendAction(GET_IAM_AVAILABLE_MODULES_TREE_URL, request);
}
